import { useTranslation } from 'react-i18next';
import { CheckCircle2, AlertTriangle, XCircle, Boxes } from 'lucide-react';

import type { CoverageKpis } from '@/services/inventorySimulationService';

interface CoverageKpisProps {
  kpis: CoverageKpis;
  loading?: boolean;
}

export function CoverageKpisCards({ kpis, loading }: CoverageKpisProps) {
  const { t } = useTranslation();

  const cards = [
    {
      key: 'total',
      label: t('inventorySimulation.kpis.total'),
      value: kpis.total,
      icon: <Boxes className="h-5 w-5 text-gray-500" />,
      className: 'border-gray-200',
    },
    {
      key: 'covered',
      label: t('inventorySimulation.kpis.covered'),
      value: kpis.covered,
      icon: <CheckCircle2 className="h-5 w-5 text-emerald-600" />,
      className: 'border-emerald-200 bg-emerald-50/40',
    },
    {
      key: 'below_safety',
      label: t('inventorySimulation.kpis.belowSafety'),
      value: kpis.below_safety,
      icon: <AlertTriangle className="h-5 w-5 text-amber-600" />,
      className: 'border-amber-200 bg-amber-50/40',
    },
    {
      key: 'stockout',
      label: t('inventorySimulation.kpis.stockout'),
      value: kpis.stockout,
      icon: <XCircle className="h-5 w-5 text-red-600" />,
      className: 'border-red-200 bg-red-50/40',
    },
  ];

  return (
    <div className="grid grid-cols-2 gap-3 md:grid-cols-4">
      {cards.map((card) => (
        <div
          key={card.key}
          className={`flex items-center justify-between rounded-lg border bg-white px-4 py-3 shadow-sm ${card.className}`}
        >
          <div className="min-w-0">
            <p className="truncate text-xs font-medium text-gray-500">{card.label}</p>
            <p className="mt-0.5 text-2xl font-bold text-gray-900">
              {loading ? '—' : card.value.toLocaleString('es-ES')}
            </p>
          </div>
          {card.icon}
        </div>
      ))}
    </div>
  );
}
